<template>
  <v-btn
      :color="color"
      rounded
      elevation="0"
      :outlined="outlined"
      :class="lowerCase ? 'no-text-transform mr-3 mb-3 mb-md-0 white--text' : 'mr-3 mb-3 mb-md-0 white--text'"
      @click="$emit('clickedButton')"
      :disabled="disabled"
      :small="small"
      :text="text"
  >
    <v-icon v-if="icon" :left="btnText != null">{{ icon }}</v-icon>
    {{ btnText }}
  </v-btn>
</template>

<script>
export default {
  name: "BaseButton",
  props: {
    color: String,
    btnText: String,
    icon: String,
    outlined: Boolean,
    lowerCase: Boolean,
    disabled: Boolean,
    small: Boolean,
    text: Boolean
  }
}
</script>
